import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";
import { performGlobalLogout } from './authSlice';

// Async thunk to fetch settled bets for a user
export const fetchSettledBets = createAsyncThunk(
  "settledBets/fetchSettledBets",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/bets/settled-bets/${userId}`);
      console.log("API response:", res.data); // 🔍 check here
      return res.data;
    } catch (err) {
      console.error("Error fetching settled bets:", err);
      return rejectWithValue(err.response?.data || { message: "Failed to fetch settled bets" });
    }
  }
);


const settledBetsSlice = createSlice({
  name: "settledBets",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetSettledBets: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettledBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSettledBets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchSettledBets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching settled bets";
      })
      // GLOBAL LOGOUT
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.data = [];
        state.loading = false;
        state.error = null;
      });
  },
});

export const { resetSettledBets } = settledBetsSlice.actions;
export default settledBetsSlice.reducer;
